import React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { useLocation } from "react-router-dom"
import StudentLogo from "./StudentLogo"
import StudentNavItem from "./StudentNavItem"
import { studentNavItems } from "./config/studentNavItems"
import { isStudentNavActive } from "./utils/isStudentNavActive"
import "./StudentSidebar.style.scss"

interface StudentSidebarProps {
  collapsed: boolean
  onToggleCollapse: () => void
}

const StudentSidebar = ({ collapsed, onToggleCollapse }: StudentSidebarProps) => {
  const { pathname } = useLocation()

  return (
    <aside
      className={`student-sidebar ${collapsed ? "student-sidebar--collapsed" : ""}`}
    >
      <div className="student-sidebar__brand">
        <StudentLogo size={collapsed ? "md" : "lg"} collapsed={collapsed} />
      </div>

      <nav className="student-sidebar__nav" aria-label="Student navigation">
        {studentNavItems.map((item) => (
          <StudentNavItem
            key={item.path}
            {...item}
            active={isStudentNavActive(pathname, item.path)}
            collapsed={collapsed}
            variant="sidebar"
          />
        ))}
      </nav>

      <div className="student-sidebar__footer">
        <button
          type="button"
          className="student-sidebar__collapse-btn"
          onClick={onToggleCollapse}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {collapsed ? (
            <ChevronRight className="student-sidebar__collapse-icon" />
          ) : (
            <ChevronLeft className="student-sidebar__collapse-icon" />
          )}
          {!collapsed && (
            <span className="student-sidebar__collapse-label">Collapse</span>
          )}
        </button>
      </div>
    </aside>
  )
}

export default StudentSidebar
